import useApiClient from './useApiClient';
import LodgeApiClient from '../../api/clients/LodgeApiClient';

const useLodgeApi = apiVer => useApiClient(LodgeApiClient, apiVer);

export default useLodgeApi;
